import React from "react";
import { useLocation } from "react-router-dom";
import { isPublicSiteRoute } from "../../features/vacationPackagesPublic/publicSiteIdentity";
import {
  PACKAGE_TIER_LABELS,
  PACKAGE_TIERS,
  VIEW_MODE_LABELS,
  VIEW_MODES,
} from "./constants";
import { useDevViewMode } from "./DevViewModeContext";
import { canAdminUseDevViewOverride } from "./isDevViewModeEnabled";
import "./DevViewModeSwitch.scss";

export default function DevViewModeSwitch() {
  const { pathname } = useLocation();
  if (!canAdminUseDevViewOverride()) return null;
  if (isPublicSiteRoute(pathname)) return null;

  return <DevViewModeSwitchInner />;
}

function DevViewModeSwitchInner() {
  const { mode, setMode, packageTier, setPackageTier } = useDevViewMode();

  return (
    <div
      className="hr-dev-view-mode"
      role="group"
      aria-label="Development view mode"
      data-testid="dev-view-mode-switch"
    >
      <span className="hr-dev-view-mode__title">DEV View</span>
      <div className="hr-dev-view-mode__options">
        {VIEW_MODES.map((option) => (
          <button
            key={option}
            type="button"
            className={`hr-dev-view-mode__btn${mode === option ? " hr-dev-view-mode__btn--active" : ""}`}
            aria-pressed={mode === option}
            onClick={() => setMode(option)}
          >
            {VIEW_MODE_LABELS[option]}
          </button>
        ))}
      </div>

      <span className="hr-dev-view-mode__title hr-dev-view-mode__title--secondary">
        Package
      </span>
      <div className="hr-dev-view-mode__options" role="group" aria-label="Package tier preview">
        {PACKAGE_TIERS.map((tier) => (
          <button
            key={tier}
            type="button"
            className={`hr-dev-view-mode__btn${packageTier === tier ? " hr-dev-view-mode__btn--active" : ""}`}
            aria-pressed={packageTier === tier}
            onClick={() =>
              setPackageTier(packageTier === tier ? null : tier)
            }
          >
            {PACKAGE_TIER_LABELS[tier]}
          </button>
        ))}
      </div>

      <p className="hr-dev-view-mode__note" data-testid="dev-view-permissions-note">
        תצוגת פיתוח בלבד — אינה משנה הרשאות שרת
      </p>
    </div>
  );
}
